import { usePlan } from "@/context/PlanContext";
import LockedFeature from "@/components/LockedFeature";

const MODULE_META = {
  formation: { title: "Business Formation", desc: "Launch your entity step by step with guided formation, EIN, licenses and banking setup." },
  credit: { title: "Business Credit", desc: "Build and monitor business credit, track vendor accounts and your credibility score." },
  funding: { title: "Funding Center", desc: "Assess funding readiness, match to capital options and track applications." },
  contracts: { title: "Contracts & Agreements", desc: "Generate, edit and manage professional contracts with an AI assistant." },
  compliance: { title: "Compliance Center", desc: "Stay legally compliant and in good standing with automated tracking." },
  portal: { title: "Client Portal", desc: "Collaborate with clients and your team in a shared, branded workspace." },
};

const SpinnerScreen = () => (
  <div className="flex items-center justify-center min-h-[60vh]" data-testid="module-gate-loading">
    <div className="w-8 h-8 border-2 border-[#D4AF37] border-t-transparent rounded-full animate-spin" />
  </div>
);

/** Wrap a route so users without the module see an upgrade prompt instead of a broken page. */
export default function ModuleGate({ moduleKey, children }) {
  const { hasModule, loading } = usePlan();
  if (loading) return <SpinnerScreen />;
  if (hasModule(moduleKey)) return children;
  const meta = MODULE_META[moduleKey] || { title: "Premium module", desc: "This module isn't included in your current plan." };
  return <LockedFeature title={meta.title} description={meta.desc} featureKey={moduleKey} />;
}
